module.exports = __webpack_public_path__ + "static/img/boy-keyboard.cae615c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/boy-keyboard.png
// module id = 271
// module chunks = 1